import { configureStore } from '@reduxjs/toolkit';
import { roundReducer, backgroundColorReducer,FontColorReducer,gameSettingsReducer,localizationReducer,audioReducer, backgroundImgReducer,logoReducer,gameNameReducer,codeReducer,mobileReducer,languageReducer } from './action'; // Import both reducers


const store = configureStore({
  reducer: {
    round: roundReducer,
    backgroundColor: backgroundColorReducer, // Use the separate gameReducer
    fontColor:FontColorReducer,
    gameSettings: gameSettingsReducer,
    audio: audioReducer, 
    backgroundImg:backgroundImgReducer,
    logo:logoReducer,
    gameName :gameNameReducer,
    code:codeReducer,
    mobile: mobileReducer,
    localization: localizationReducer,
    language: languageReducer,
  },
});

export default store;